import React from 'react'
import { Icon } from 'antd'
import styles from './index.less'

const Notfound = () => <div className="content-inner">
    <div className={styles.notfound}>
      <Icon type="frown-o" />
    </div>
  </div>

export default Notfound
